/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>



      <AsideMenuItem to="/apps/connection-management/connection" title="Connection" />
      <AsideMenuItem to="/apps/sources-management/sources" title="Sources" />
      <AsideMenuItem to="/apps/destinations-management/destinations" title="Destinations" />
      <AsideMenuItem
        to='/apps/user-management/users'
        title='User management'
      />

    </>
  )
}
